<template>
  <div id="addendum">
    <div class="px3 py4 mb4">
      <h2 class="mb3">Arbejdsseddel</h2>
      <div class="clearfix" v-if="loading">
        <Loading></Loading>
      </div>
      <div v-else>
        <div class="flex flex-wrap justify-between mb3">
          <div>
            <div class="flex mb1">
              <div class="col-4 p0">
                <h6>For perioden: Uge</h6>
              </div>
              <div>
                <el-input-number v-model="period.week" :min="0" controls-position="right" class="col-8 p0"></el-input-number>
                <p class="mini mediumgrey m0">{{period.weekDate}}</p>
              </div>
              <el-date-picker
                v-model="period.year"
                type="year"
                value-format="yyyy">
              </el-date-picker>
            </div>
            <h6>Fra: {{companyName}}</h6>
            <h6>Til : Homeowner Test</h6>
          </div>
          <div>
            <h6>Ifølge kontrakt løbenummer </h6>
            <h6>{ContractName}</h6>
            <h6>ID :  {ContractID}</h6>
          </div>
          <div>
            <h6>Indrapporteret: {{dateNow}}</h6>
            <div class="flex flex-wrap items-center mb1">
              <div class="col-4 p0">
                <h6>Udfyldt af:</h6> 
              </div>
              <div class="col-8 p0">
                <el-input v-model="userName"></el-input>
              </div>
            </div>
            <h6>ArbejdsSeddel: {ID}</h6>
          </div>
        </div>
        <div class="flex flex-column items-center mb3">
          <h6>{{budgetPlannedQuestionInfo.label}}?</h6>
          <div class="flex flex-column pl2">
            <el-radio v-model="isBudgetPlanned" :label="values" v-for="(values, index) in budgetPlannedQuestionInfo.values" :key="index">{{values}}</el-radio>
          </div>
        </div>
        
        <!-- Time -->
        <div class="mb3">
          <h6>Timer</h6>
          <el-table
            :data="timeData"
            border
            style="width: 100%">
            <el-table-column
              prop="day"
              label="Dag">
            </el-table-column>
            <el-table-column
              prop="description"
              label="Description">
              <template slot-scope="props">
                <el-input v-model="props.row.description" type="textarea"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="quantity"
              label="Antal">
              <template slot-scope="props">
                <el-input-number v-model="props.row.quantity" :min="0" controls-position="right" @change="calculateSum(props.$index, 'time')"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              prop="price"
              label="Pris">
              <template slot-scope="props">
                <el-input-number v-model="props.row.price" :min="0" :controls="false" @change="calculateSum(props.$index, 'time')"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              prop="sum"
              label="Sum">
              <template slot-scope="props">
                {{formatPrice(props.row.sum)}}
              </template>
            </el-table-column>
          </el-table>
          <div class="flex flex-wrap justify-between py3">
            <h6>Sum af Timer inkl. moms:</h6>
            <h6>{{formatPrice(timeDataTotal)}}</h6>
          </div>
        </div>

        <!-- Materialer -->
        <div class="mb2">
          <h6>Materialer</h6>
          <el-table
            :data="materialsData"
            border
            style="width: 100%">
            <el-table-column
              prop="itemNumDescription"
              label="Vare nummer Beskrivelse/matriale">
                <template slot-scope="props">
                  <el-input v-model="props.row.itemNumDescription" type="textarea"></el-input>
                </template>
            </el-table-column>
            <el-table-column
              prop="quantity"
              label="Antal">
              <template slot-scope="props">
                <el-input-number v-model="props.row.quantity" :min="1" controls-position="right" @change="calculateSum(props.$index, 'material')"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              prop="price"
              label="Pris">
              <template slot-scope="props">
                <el-input-number v-model="props.row.price" :min="1" :controls="false" @change="calculateSum(props.$index, 'material')"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              prop="sum"
              label="Sum">
              <template slot-scope="props">
                {{formatPrice(props.row.sum)}}
              </template>
            </el-table-column>
          </el-table>
          <div class="flex flex-wrap justify-between py3">
            <h6>Sum af materialer inkl moms:</h6>
            <h6>{{formatPrice(materialsDataTotal)}}</h6>
          </div>
        </div>

        <div class="flex flex-wrap justify-between">
          <h6>Sum af timer og matrialer</h6>
          <h6>{{formatPrice(timeDataAndmaterialsDataTotal)}}</h6>
        </div>

        <div class="flex flex-wrap justify-between mb3">
          <h6>Herfra Moms ( 25% ) </h6>
          <h6>{{formatPrice(timeDataAndmaterialsDataTotal * 25 / 100)}}</h6>
        </div>

        <div class="col-10 p0 mb2">
          <h6>Andre Bemærkninger:</h6>
          <el-input v-model="remarks" type="textarea" :autosize="{ minRows: 8}"></el-input>
        </div>

        <button type="button" class="action-button py2 px3 m0 gibson not-rounded border-none regular right" @click="addWorkSheet()">
          Indsend til kunden for godkendelse
        </button>

      </div>
      <div class="my4"></div>
    </div>
     <ErrorHandler ref="errorMsg"></ErrorHandler>
  </div>
</template>
<script>
import moment from 'moment'
const Loading = () => import('@/components/Loading')
const ErrorHandler = () => import('@/components/ErrorHandler')
export default {
  components: {
    Loading,
    ErrorHandler
  },
  name: 'Addendum',
  data () {
    return {
      loading: true,
      salesPerson: localStorage.getItem('id_token_portalbitrix'),
      userName: localStorage.getItem('name'),
      companyName: localStorage.getItem('CompanyName'),
      period: {
        week: undefined,
        weekDate: '',
        year: ''
      },
      dateNow: moment(new Date()).locale('da').format('LL'),
      budgetPlannedQuestionInfo: {},
      isBudgetPlanned: null,
      timeData: [{
        day: 'Mandag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        day: 'Tirsdag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        day: 'Onsdag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        day: 'Torsdag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        day: 'Fredag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        day: 'Lørdag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        day: 'Søndag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }],
      timeDataTotal: 0,
      materialsData: [{
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }],
      materialsDataTotal: 0,
      timeDataAndmaterialsDataTotal: 0,
      remarks: '',
      currentProjectInfo: {}
    }
  },
  mounted () {
    this.displayCurrentProject()
  },
  methods: {
    displayCurrentProject () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/projects', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.data && res.data.length > 0) {
            res.data.forEach((projectProp, projectPropIndex) => {
              if (projectProp.IS_ACTIVE === 1) {
                this.currentProjectInfo = projectProp
                this.getContractTemplates()
              }
            })
          }
        },
        response => {
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        })
    },
    getContractTemplates () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {}
      this.$http.post(this.$bitrixapi + 'partner/contract/GetAllContractTemplates', data, { headers }, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          if (res.data && res.data.length > 0) {
            this.budgetPlannedQuestionInfo = res.data.filter((property) => { return property.NAME === 'Arbejds seddel' })[0].STEPS.step_34.fields[1]
            this.isBudgetPlanned = this.budgetPlannedQuestionInfo.default_value
          }
          this.period.year = new Date().getFullYear().toString()
          this.getCurrentNumberOfWeeks()
          this.loading = false
        },
        response => {
          this.loading = false
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        }
      )
    },
    getCurrentNumberOfWeeks () {
      var todayDate = new Date()
      var oneJan = new Date(todayDate.getFullYear(), 0, 1)
      var numberOfDays = Math.floor((todayDate - oneJan) / (24 * 60 * 60 * 1000))
      this.period.week = Math.ceil(((todayDate.getDay() + 1 + numberOfDays) / 7) - 1)

      var goBack = todayDate.getDay() % 7 + 6
      var lastMonday = new Date().setDate(todayDate.getDate() - goBack)
      var desiredDate = new Date(lastMonday)
      this.period.weekDate = moment(desiredDate).locale('da').format('LL')
    },
    calculateSum (index, type) {
      var data = []
      this.timeDataAndmaterialsDataTotal = 0
      if (type === 'time') {
        data = this.timeData
        this.timeDataTotal = 0
      } else {
        data = this.materialsData
        this.materialsDataTotal = 0
      }
      data.forEach((prop, propIndex) => {
        // if (propIndex === index) {
        if (prop.price && prop.quantity) {
          prop.sum = prop.price * prop.quantity
          if (type === 'time') {
            this.timeDataTotal += prop.sum
          } else {
            this.materialsDataTotal += prop.sum
          }
        }
        // }
      })
      this.timeDataAndmaterialsDataTotal = this.timeDataTotal + this.materialsDataTotal
    },
    formatPrice (amount) {
      let formatter = new Intl.NumberFormat('da-DK', {
        style: 'currency',
        currency: 'DKK',
        minimumFractionDigits: 2
      })
      var tempno = formatter.format(amount)
      return tempno
    },
    addWorkSheet () {
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var period = this.period
      var dateNow = this.dateNow
      var budgetPlannedQuestionInfo = this.budgetPlannedQuestionInfo
      var isBudgetPlanned = this.isBudgetPlanned
      var timeData = this.timeData
      var timeDataTotal = this.timeDataTotal
      var materialsData = this.materialsData
      var materialsDataTotal = this.materialsDataTotal
      var timeDataAndmaterialsDataTotal = this.timeDataAndmaterialsDataTotal
      var remarks = this.remarks
      var data = {
        contactId: this.currentProjectInfo.HOMEOWNER.ID,
        projectId: this.currentProjectInfo.ID,
        submittedData: {
          period,
          dateNow,
          budgetPlannedQuestionInfo,
          isBudgetPlanned,
          timeData,
          timeDataTotal,
          materialsData,
          materialsDataTotal,
          timeDataAndmaterialsDataTotal,
          remarks
        }
      }
      this.$http.post(this.$bitrixapi + 'partner/worksheet/add', data, { headers }, { emulateJSON: true }).then(
        response => {
          // var res = response.body
          this.displayCurrentProject()
          this.clearFields()
          this.loading = false
          this.$message({
            type: 'success',
            message: 'Succes'
          })
        },
        response => {
          this.loading = false
          var error = response.body
          this.$refs.errorMsg.showMsg(error)
        }
      )
    },
    clearFields () {
      this.period.week = undefined
      this.period.weekDate = ''
      this.period.year = ''
      this.dateNow = ''
      this.budgetPlannedQuestionInfo = {}
      this.isBudgetPlanned = null
      this.timeData = [{
        day: 'Mandag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        day: 'Tirsdag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        day: 'Onsdag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        day: 'Torsdag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        day: 'Fredag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        day: 'Lørdag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        day: 'Søndag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }]
      this.timeDataTotal = null
      this.materialsData = [{
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      },
      {
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }]
      this.materialsDataTotal = null
      this.timeDataAndmaterialsDataTotal = null
      this.remarks = ''
    }
  }
}
</script>
<style>
  #addendum .el-input-number input {
    text-align: left
  }
  #addendum .el-input__icon {
    height: 0;
  }
</style>


// WEBPACK FOOTER //
// addendum.vue?614fef2c